"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container flex-col" };
const _hoisted_2 = { class: "card-container" };
const vue_3 = require("vue");
const CustomButton_vue_1 = __importDefault(require("../../../components/backend/CustomButton.vue"));
const companyServicesStore_1 = require("../../../stores/backend/companyService/companyServicesStore");
const CompanyLocationStore_1 = require("../../../stores/backend/company/CompanyLocationStore");
const ServiceElement_vue_1 = __importDefault(require("./ServiceElement.vue"));
const vue_router_1 = require("vue-router");
const vue_4 = require("vue");
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Services',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const successId = (0, vue_4.ref)("");
        const deleted = (0, vue_4.ref)(false);
        (0, vue_4.onMounted)(() => {
            if (route.query.success === "true" && route.query.id) {
                successId.value = String(route.query.id);
            }
            if (route.query.deleted === "true") {
                deleted.value = true;
            }
        });
        const serviceStore = (0, companyServicesStore_1.useCompanyServicesStore)();
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        (0, vue_3.onBeforeMount)(() => {
            if (companyLocationStore.selectedCompany &&
                companyLocationStore.selectedCompany.id) {
                serviceStore.fetchServices(companyLocationStore.selectedCompany.id);
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (successId.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: _ctx.$trans('service_save_success_message', 'Saved succesfully. Identifier: ', 'service_list') + successId.value,
                        variant: "success",
                        class: "rounded-t-none",
                        "icon-class": "marso-icon-check"
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (deleted.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 1,
                        message: _ctx.$trans('service_delete_success_message', 'Deleted succesfully.', 'service_list'),
                        variant: "success",
                        class: "rounded-t-none",
                        "icon-class": "marso-icon-check"
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                        to: { name: 'service_new' },
                        "btn-type": "primary",
                        class: "w-98"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("new_service", "New Service", "services_list")), 1)
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(serviceStore).services, (service) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ServiceElement_vue_1.default, {
                                key: service.id,
                                "service-name": service.name,
                                "is-active": (0, vue_2.unref)(serviceStore).isActive(service),
                                duration: service.duration,
                                "service-id": service.id,
                                "assigned-locations": service.assignedLocations.map((location) => location.toString()),
                                price: service.online_price
                            }, null, 8, ["service-name", "is-active", "duration", "service-id", "assigned-locations", "price"]));
                        }), 128))
                    ])
                ])
            ], 64));
        };
    }
});
